import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { IIssueState } from "@common/interfaces/issueState";
import { Topics } from "@common/interfaces/topics";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";

export interface IssueStateState extends EntityState<IIssueState, ID> { }

@Injectable({
    providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.ISSUE_STATES , realtimeEntity: 'IssueState'})
export class IssueStateStore extends EntityStore<IssueStateState> {
    constructor() {
        super([]);
    }
}
